import { State } from './types';
import { Actions, RESET_CART, SET_CART, SET_RECOVERED_CART } from './actions';

export const NAMESPACE = 'cart';

const initialState: State = {
    cart: null,
    recoveredCart: null,
};

export const reducer = (state: State = initialState, action: Actions) => {
    switch (action.type) {
        case RESET_CART:
            return { ...state, cart: null, recoveredCart: null };
        case SET_CART:
            return { ...state, cart: action.payload.cart };
        case SET_RECOVERED_CART:
            return { ...state, recoveredCart: action.payload.recoveredCart };
        default:
            return state;
    }
};

export default reducer;
